import { render, staticRenderFns } from "./ButtonTemplate.vue?vue&type=template&id=67442af3&scoped=true&"
import script from "./ButtonTemplate.vue?vue&type=script&lang=js&"
export * from "./ButtonTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ButtonTemplate.vue?vue&type=style&index=0&id=67442af3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67442af3",
  null
  
)

export default component.exports